import { CreaturesConst } from "../const/creaturesConst"
import { FriendRequestWithUserType } from "../context/friends/types/friendRequestWithUserType"

export const getUserFromFriendRequests = (friendRequests: FriendRequestWithUserType[]|undefined, id: string) => {
    if (!friendRequests) return null
    return friendRequests.find((user) => {
        return user.user.id === id
    })?.user
}